import Banner from './banner'
import Menu from './menu'
import type { IHeaderProps } from '../types/components/IHeader'

export default function Header(props: IHeaderProps) {
  return (
    <>
      {props.banner && <Banner />}
      <header className="sticky top-0 z-10 bg-white group group:sticky:shadow-md">
        <Menu />
      </header>
    </>
  )
}
